<template>
  <div class="register-page">
    <div :class="computedClass">
      <!-- <div class="page-title col-xs-12 col-sm-6 pt-2">
        Registrar / Dispositivos ({{ list.length }})
      </div> -->
      <div class="col-lg-6 d-flex align-items-center">
        <PageTitle
          :titles="['Cadastrar', 'Dispositivos']"
          :dataCount="list.length"
        />
      </div>
      <toolbar
        class="col-xs-12 col-sm-6"
        type="dirs"
        :is-mobile="mobile"
        :is-searching="isSearching"
        @search="searchBy"
        @clear-search="clearSearch"
        @edit="edit"
        @remove="remove()"
        @add="add"
        ref="INP"
        :is-admin="isAdmin"
        :selected="selected"
        :number-of-elements="list.length"
        :type-filtering="''"
        :not-exists="showErrorNotFound"
        :not-search="showErrorNotSearch"
        :is-show="loading"
      />
    </div>
    <!-- DROPDOWN -->
    <div class="container-dropdown">
      <div class="row around-xs">
        <!-- :variant="!tab1 ? 'outline-3v3' : '3v3'" -->
        <b-dropdown
          :text="!tabSelected ? 'EXIBIR DIRS' : tabSelected.toUpperCase()"
          class="col-xs-6 pt-1"
          size="sm"
          :disabled="showErrorNotSearch || loading"
          :variant="$route.params.type === 'models' ? 'outline-3v3' : '3v3'"
        >
          <b-dropdown-item to="/registers/devices" @click="selectType(null)">
            EXIBIR DIRS
          </b-dropdown-item>
          <b-dropdown-item
            v-for="e in optionsLeft"
            :key="e.NAME"
            to="/registers/devices"
            @click="selectType(e.NAME)"
            >{{ e.NAME }}
          </b-dropdown-item>
        </b-dropdown>

        <div class="col-xs-6 pt-1">
          <b-button
            block
            to="/registers/devices/models"
            :variant="$route.params.type === 'models' ? '3v3' : 'outline-3v3'"
            :disabled="showErrorNotSearch || loading"
            size="sm"
          >
            MODELOS
          </b-button>
        </div>
      </div>
    </div>

    <!-- CARDS -->
    <div class="register-main">
      <div class="list-items row">
        <div v-if="loading" class="col-xs-12 center-xs">
          <spinner /> Aguarde...
        </div>

        <div
          v-if="showErrorNotFound"
          class="EmptyRequest w-100 h-100 p-0 row center-xs center-md center-sm center-xs mt-3"
        >
          <img :src="emptyIcon" class="empty" />
          <span>Não há dispositivos para exibir.</span>
        </div>

        <div
          v-if="showErrorNotSearch && !showErrorNotFound"
          class="EmptyRequest row center-xs mx-2 md-12 w-100 p-0 mt-3"
          style="text-align: left"
        >
          <img :src="searchIcon" class="empty" />
          <span>
            Não há dispositivos para exibir. Para voltar a exibir todos os
            dispositivos
            <b-link
              @click="
                (evt) => {
                  resetDropdown();
                  myRouteSelected();
                }
              "
            >
              clique aqui </b-link
            >.</span
          >
        </div>

        <div
          v-show="!loading"
          v-for="(item, index) in list"
          :key="index"
          class="col-xs-12 col-sm-4 col-md-3"
        >
          <div class="item-card dir-card">
            <div class="header-card">
              <div class="card-name">
                <h5 v-if="type != 'models'">
                  <!-- {{ item.NAME ? item.NAME : `Dispositivo ${item.ADDR}` }} -->
                  {{ item.ADDR >= 0 ? `Dispositivo ${item.ADDR}` : item.NAME }}
                </h5>
                <h5 v-if="type === 'models'">
                  {{ item.NAME }}
                </h5>
                <source-branch-icon
                  title="Está em rota"
                  v-if="isDirsInRoutes(item)"
                />
              </div>
              <span class="info">{{
                type === "models"
                  ? item.MAKER
                  : item.MODEL_NAME
                  ? item.MODEL_NAME
                  : item.NAMEW
              }}</span>
            </div>

            <div v-if="type == 'models'" class="row-details-card">
              <div>
                <strong>Saídas:</strong> <span>{{ item.OUT }}</span>
              </div>
              <div>
                <strong>Entradas Digitais:</strong> {{ item.IN_DIGITAL }}
              </div>
              <div>
                <strong>Entradas Analógicas:</strong> {{ item.IN_ANALOGIC }}
              </div>
              <div><strong>Saída I2C:</strong> {{ item.IN_I2C }}</div>
              <div><strong>Saída SDI12:</strong> {{ item.IN_SDI12 }}</div>
            </div>
            <div v-else>
              <div
                v-if="item.LATITUDE != null || item.LONGITUDE != null"
                class="row-details-card"
              >
                <div class="slider">
                  <strong>Coordenadas: </strong>
                  {{ `${item.LATITUDE || "?"}, ${item.LONGITUDE}` }}
                </div>
              </div>
              <div v-if="item.UID" class="row-details-card">
                <strong>UID:</strong> {{ item.UID }}
              </div>
              <div v-if="item.ORIGIN >= 0" class="row-details-card">
                <strong>Origem:</strong> {{ item.ORIGIN }}
              </div>
              <div v-if="item.NOTE" class="row-details-card">
                <strong>Observação:</strong> {{ item.NOTE }}
              </div>
              <div class="show-details-cards mt-1">
                <b-link @click="openDetails(item)">Ver equipamentos</b-link>
              </div>
            </div>
            <div class="footer">
              <b-checkbox
                class="checkbox"
                :value="item"
                v-model="selected"
                v-show="isAdmin"
              />
              <settings-outline-icon
                class="action-icon-right details-btn"
                title="Configurações EMR"
                v-if="
                  isAdmin &&
                  item.MODEL_NAME &&
                  item.MODEL_NAME.indexOf('EMR') > -1
                "
                @click.native="emrConfig(item)"
              />
              <!-- <settings-outline-icon
                class="action-icon-right details-btn"
                title="Configurações EMR"
                v-if="
                  isAdmin && !type && item.NAME && item.NAME.indexOf('EMR') > -1
                "
                @click.native="emrConfig(item)"
              /> -->
              <settings-outline-icon
                class="action-icon-right details-btn"
                title="Configurações FIR"
                v-if="
                  isAdmin &&
                  item.MODEL_NAME &&
                  item.MODEL_NAME.indexOf('FIR') > -1
                "
                @click.native="firConfig(item)"
              />
              <!-- <settings-outline-icon
                class="action-icon-right details-btn"
                title="Configurações FIR"
                v-if="
                  isAdmin && !type && item.NAME && item.NAME.indexOf('FIR') > -1
                "
                @click.native="firConfig(item)"
              /> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL DE REMOÇÃO DE DIRS / MODELOS -->
    <b-modal
      ref="removeDirs"
      centered
      size="sm"
      ok-title="Deletar"
      @ok="confirmRemove"
      ok-variant="danger"
      cancel-title="Cancelar"
      @cancel="selected = []"
      cancel-variant="outline-secondary"
      title="Atenção!"
    >
      <div class="title-modal-info">
        {{
          selected.length == 1
            ? `1 modelo será removido`
            : selected.length + " modelos serão apagados"
        }}.
      </div>
    </b-modal>

    <!-- MOSTRAR DISPOSITIVOS -- DETALHES -->
    <div v-if="showDetails && !showForm">
      <div id="overlay" @click="showDetails = false"></div>
      <div id="details" class="pr-0 pl-0">
        <header id="header" class="row">
          <div class="col-xs-12 monit-item bg-3v3">
            <h5 class="header-title">
              Dispositivo {{ details.ADDR ? details.ADDR : details.NAME }}
            </h5>
          </div>
        </header>
        <div class="column content pb-10 details-area pl-0 pr-0">
          <div
            class="pr-3 pl-3"
            v-if="
              details.VALVE &&
              details.VALVE.filter((e) => !!e.CURRENT_EQUIPMENT).length
            "
          >
            <h5>Atuadores</h5>
            <div class="selected-box">
              <div
                class="selected-item"
                v-for="(item, index) in details.VALVE.filter(
                  (e) => !!e.CURRENT_EQUIPMENT
                )"
                :key="index"
              >
                <div class="identifier">{{ item.POSITION }}</div>
                {{ item.NAME_EQUIPMENT }} {{ getOperationMode(item.OPERATION) }}
              </div>
            </div>
          </div>
          <div
            class="pr-3 pl-3"
            v-if="
              details.P_MODBUS &&
              details.P_MODBUS.filter((e) => !!e.CURRENT_EQUIPMENT).length
            "
          >
            <h5>Bombas modbus</h5>
            <div class="selected-box">
              <div
                class="selected-item"
                v-for="(item, index) in details.P_MODBUS.filter(
                  (e) => !!e.CURRENT_EQUIPMENT
                )"
                :key="index"
              >
                <div class="identifier">{{ item.POSITION }}</div>
                {{ item.NAME_EQUIPMENT }}
              </div>
            </div>
          </div>

          <div
            class="pr-3 pl-3"
            v-if="
              details.S_MODBUS &&
              details.S_MODBUS.filter((e) => !!e.CURRENT_EQUIPMENT).length
            "
          >
            <h5>Sensores modbus</h5>
            <div class="selected-box">
              <div
                class="selected-item"
                v-for="(item, index) in details.S_MODBUS.filter(
                  (e) => !!e.CURRENT_EQUIPMENT
                )"
                :key="index"
              >
                <div class="identifier">{{ item.POSITION }}</div>
                {{ item.NAME_EQUIPMENT }}
              </div>
            </div>
          </div>

          <div
            class="pr-3 pl-3"
            v-if="
              details.HYDRO.filter((e) => !!e.CURRENT_EQUIPMENT).length &&
              !details.PULSE.filter((e) => !!e.CURRENT_EQUIPMENT).length
            "
          >
            <h5>Entradas digitais</h5>
            <div class="selected-box">
              <div
                class="selected-item"
                v-for="(n, index) in details.DIGITAL_CAPACITY"
                :key="n"
              >
                <div
                  v-if="
                    details.HYDRO[index].CURRENT_EQUIPMENT ||
                    details.PULSE[index].CURRENT_EQUIPMENT
                  "
                >
                  <div class="identifier">{{ n }}</div>
                  {{ digitalInput(index) }}
                </div>
              </div>
            </div>
          </div>

          <div
            class="pr-3 pl-3"
            v-if="
              details.SENSOR &&
              details.SENSOR.filter((e) => !!e.CURRENT_EQUIPMENT).length
            "
          >
            <h5>Sensores analógicos</h5>
            <div class="selected-box">
              <div
                class="selected-item"
                v-for="(item, index) in details.SENSOR.filter(
                  (e) => !!e.CURRENT_EQUIPMENT
                )"
                :key="index"
              >
                <div class="identifier">{{ item.POSITION }}</div>
                {{ item.NAME_EQUIPMENT }}
              </div>
            </div>
          </div>

          <div class="pr-3 pl-3" v-if="details.EMR">
            <h5>Sensor de estação</h5>
            <div class="selected-box">
              <div class="selected-item">
                {{ details.EQUIP_ON_EMR }}
              </div>
            </div>
          </div>

          <div class="pr-3 pl-3" v-if="details.PIR">
            <h5>Sensor PIR</h5>
            <div class="selected-box">
              <div class="selected-item">
                {{ details.EQUIP_ON_PIR }}
              </div>
            </div>
          </div>

          <div
            class="pr-3 pl-3"
            v-if="
              details.ONOFF &&
              details.ONOFF.filter((e) => !!e.CURRENT_EQUIPMENT).length
            "
          >
            <h5>Sensores On/Off</h5>
            <div class="selected-box">
              <div
                class="selected-item"
                v-for="(item, index) in details.ONOFF.filter(
                  (e) => !!e.CURRENT_EQUIPMENT
                )"
                :key="index"
              >
                <div class="identifier">{{ item.POSITION }}</div>
                {{ item.NAME_EQUIPMENT }}
              </div>
            </div>
          </div>

          <div
            class="pr-3 pl-3"
            v-if="
              details.I2C &&
              details.I2C.filter((e) => !!e.CURRENT_EQUIPMENT).length
            "
          >
            <h5>Sensores I2C</h5>
            <div class="selected-box">
              <div
                class="selected-item"
                v-for="(item, index) in details.I2C.filter(
                  (e) => !!e.CURRENT_EQUIPMENT
                )"
                :key="index"
              >
                <div class="identifier">{{ item.POSITION }}</div>
                {{ item.NAME_EQUIPMENT }}
              </div>
            </div>
          </div>

          <div
            class="pr-3 pl-3"
            v-if="
              details.SDI12 &&
              details.SDI12.filter((e) => !!e.CURRENT_EQUIPMENT).length
            "
          >
            <h5>Sensores SDI-12</h5>
            <div class="selected-box">
              <div
                class="selected-item"
                v-for="(item, index) in details.SDI12.filter(
                  (e) => !!e.CURRENT_EQUIPMENT
                )"
                :key="index"
              >
                <div v-if="item.CURRENT_EQUIPMENT">
                  <div class="identifier">{{ item.POSITION }}</div>
                  {{ item.NAME_EQUIPMENT }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="EmptyRequest w-100 h-100 pl-xs-0 pl-4 row center-xs center-md center-sm center-xs mt-3"
            v-if="detailsInfo"
          >
            <img :src="emptyIcon" class="empty" />
            <span class="pt-xs-2 pt-md-3 pt-xl-3"
              >Não há equipamentos para serem exibidos nesse dispositivo.</span
            >
          </div>
        </div>
        <footer id="footer">
          <b-btn size="sm" block @click="showDetails = false"> Fechar </b-btn>
        </footer>
      </div>
    </div>

    <!-- FORMULÁRIO DE DIRS E MTD -->
    <dir-form
      v-if="type !== 'models' && !showDetails && idDirForm && !isMTDForm"
      :show-form="showForm"
      :form-type="formType"
      equipment="DIR"
      :models="modelDirs"
      :DirOrMtd="regexMTD.test(type) ? 'MTD' : 'DIR'"
      :typeDropDown="type"
      :pickedMod="formType === 'add' ? pickedModel : {}"
      :already-used-addrs="fullList.length && fullList.map((e) => e.ADDR)"
      :old-addr="
        formType == 'edit' && idDirForm && selected.length && selected[0].ADDR
      "
      :item-to-edit="
        formType == 'edit' && idDirForm && selected.length && selected[0]
      "
      :emrsensors="emrsensors"
      :pirsensors="pirsensors"
      :valves="valves"
      :pumps="pumps"
      :modbus-pumps="modbusPumps"
      :hydros="hydros"
      :pulses="pulses"
      :sensors="sensors"
      :onoffs="onoffs"
      :modbus-sensors="modbusSensors"
      :sensorsi2c="sensorsi2c"
      :sensorssdi="sensorssdi"
      @submit="submitDir"
      @close-form="
        showForm = false;
        formType = '';
        idDirForm = false;
        isMTDForm = false;
      "
    />
    <mtd-form
      v-if="type !== 'models' && !showDetails && isMTDForm && !idDirForm"
      :show-form="showForm"
      :form-type="formType"
      equipment="MTD"
      :models="modelDirs"
      :pickedMod="formType === 'add' ? pickedModel : {}"
      :already-used-name="fullList.map((e) => e.NAME)"
      :old-name="
        formType == 'edit' && selected.length && selected[0].NAME
          ? selected[0].NAME
          : ''
      "
      :item-to-edit="formType == 'edit' && selected.length && selected[0]"
      :already-used-uid="filterUUIDsFromMtds"
      :emrsensors="emrsensors"
      :pirsensors="pirsensors"
      :valves="valves"
      :pumps="pumps"
      :modbus-pumps="modbusPumps"
      :hydros="hydros"
      :pulses="pulses"
      :sensors="sensors"
      :onoffs="onoffs"
      :modbus-sensors="modbusSensors"
      :sensorsi2c="sensorsi2c"
      :sensorssdi="sensorssdi"
      @submitMTD="submitMtd"
      @close-form="
        showForm = false;
        formType = '';
        idDirForm = false;
        isMTDForm = false;
      "
    />
    <show-models
      v-if="
        type !== 'models' &&
        !showDetails &&
        formType == 'add' &&
        !idDirForm &&
        !isMTDForm
      "
      :models="modelDirs"
      @model-name="formShowAdd"
      @close-form="
        showForm = false;
        formType = '';
        idDirForm = false;
        isMTDForm = false;
      "
    />

    <div v-if="showFIRConfig || showEMRConfig">
      <div
        id="overlay"
        @click="
          showEMRConfig = false;
          showFIRConfig = false;
        "
      />
      <div id="form">
        <div class="column details-area">
          <div class="col-xs-12">
            <h5 v-if="showEMRConfig">Configurar EMR {{ emrData.ADDR }}</h5>
            <h5 v-else-if="showFIRConfig">Configurar FIR {{ firData.ADDR }}</h5>
            <b-form v-if="showEMRConfig" novalidate class="col-xs-12">
              <b-form-text id="altInputLiveHelp">
                Altitude do dispositivo
              </b-form-text>
              <b-form-input
                v-model="emrData.ALTITUDE"
                placeholder="Altitude"
                aria-describedby="altInputLiveHelp altInputLiveFeedback"
                :state="ALTstate"
                maxlength="40"
                size="sm"
              />
              <b-form-invalid-feedback
                v-if="!ALTstate"
                id="altInputLiveFeedback"
              >
                Permitidos apenas números, um único ponto decimal e um único
                hífen indicando valor negativo.
              </b-form-invalid-feedback>
              <b-form-text id="hAnemInputLiveHelp">
                Altura do anemômetro (em relação ao solo):
              </b-form-text>
              <b-form-input
                v-model="emrData.H_ANEMOMETRO"
                placeholder="Altura do anemômetro"
                aria-describedby="hAnemInputLiveHelp hAnemInputLiveFeedback"
                :state="HANEMstate"
                maxlength="40"
                size="sm"
              />
              <b-form-invalid-feedback
                v-if="!HANEMstate"
                id="hAnemInputLiveFeedback"
              >
                Permitidos apenas números, um único ponto decimal. Proibido
                valor negativo.
              </b-form-invalid-feedback>
            </b-form>
            <b-form v-else-if="showFIRConfig" novalidate class="col-xs-12">
              <span class="info-config"
                >Selecione as parcelas que serão fertirrigadas pelas caixas
                ligadas a esse dispositivo de acordo com a válvula de saída.
                Essa configuração é necessária para o filtro do cadastro de
                agenda de fertirrigação. *</span
              >
              <b-btn
                block
                size="sm"
                rounded
                class="mt-2"
                @click="openValveTable('ADT1')"
                variant="orange"
                >Adicionar ou remover Saída de FERTI 1</b-btn
              >
              <div
                class="selected-box"
                v-if="
                  firOpts.ADT1.filter((e) => firData.ADT1.includes(e.ID)).length
                "
              >
                <div
                  class="selected-item"
                  v-for="(sel, index) in firOpts.ADT1.filter((e) =>
                    firData.ADT1.includes(e.ID)
                  )"
                  :key="index"
                >
                  {{ sel.NAME }}
                </div>
              </div>
              <b-btn
                block
                size="sm"
                rounded
                @click="openValveTable('ADT2')"
                variant="orange"
                >Adicionar ou remover Saída de FERTI 2</b-btn
              >
              <div
                class="selected-box"
                v-if="
                  firOpts.ADT2.filter((e) => firData.ADT2.includes(e.ID)).length
                "
              >
                <div
                  class="selected-item"
                  v-for="(sel, index) in firOpts.ADT2.filter((e) =>
                    firData.ADT2.includes(e.ID)
                  )"
                  :key="index"
                >
                  {{ sel.NAME }}
                </div>
              </div>
            </b-form>
          </div>
        </div>
        <footer id="footer">
          <!-- block -->
          <b-btn
            variant="outline-secondary"
            @click="
              showEMRConfig = false;
              showFIRConfig = false;
            "
            size="sm"
            class="ml-2 mr-1"
          >
            Fechar
          </b-btn>
          <!-- block -->
          <b-btn
            v-if="showEMRConfig"
            variant="3v3"
            size="sm"
            @click="submitEmrConfig"
            class="ml-1 mr-2"
          >
            Salvar
          </b-btn>
          <!-- block -->
          <b-btn
            v-else-if="showFIRConfig"
            variant="3v3"
            size="sm"
            @click="submitFirConfig"
            class="ml-1 mr-2"
          >
            Salvar
          </b-btn>
        </footer>
        <b-modal ref="firValves" centered hide-header hide-footer size="sm">
          <h6>
            Válvulas para {{ adt }} ({{ firData[adt].length }} selecionados)
          </h6>
          <div class="equipment-table">
            <b-table
              striped
              small
              borderless
              hover
              responsive
              :items="
                firOpts[adt].filter(
                  (valve) => !valve.ADDR || valve.ADDR == firData.ADDR
                )
              "
              :fields="fields"
            >
              <template slot="HEAD_CHECK">
                <b-form-checkbox
                  @click.native.prevent="toggleAllValves(adt)"
                  v-model="firSel[adt]"
                />
              </template>
              <template slot="CHECK" slot-scope="row">
                <b-form-checkbox :value="row.item.ID" v-model="firData[adt]" />
              </template>
              <template slot="NAME" slot-scope="row">
                {{ row.item.NAME }}
              </template>
            </b-table>
          </div>
          <b-btn
            v-if="$refs.firValves"
            block
            size="sm"
            @click="$refs.firValves.hide"
            >Voltar</b-btn
          >
        </b-modal>
      </div>
    </div>

    <dir-model-form
      v-if="type === 'models'"
      :show-form="showForm"
      :form-type="formType"
      equipment="Modelo de Dispositivo"
      :already-used-names="fullList.length && fullList.map((e) => e.NAME)"
      :old-name="formType == 'edit' && selected.length && selected[0].NAME"
      :item-to-edit="formType == 'edit' && selected.length && selected[0]"
      @submit="submitModel"
      @close-form="
        showForm = false;
        formType = '';
      "
    />
  </div>
</template>

<script>
import {
  dirs,
  mtd,
  firs,
  modelsDir,
  getAlones,
  stations,
  valves,
  routes,
} from "@/api";
import { cookies } from "@/pages/components/cookies";
import { mobile } from "@/mixins/mobile.js";
import PageTitle from "@/pages/temps/components/PageTitle.vue";
export default {
  components: {
    PageTitle,
  },
  name: "dirs",
  props: {
    mobile: Boolean,
  },
  mixins: [mobile],
  data() {
    return {
      emptyIcon: require("../../../assets/icons/Empty.svg"),
      searchIcon: require("../../../assets/icons/search.svg"),
      title: "",
      idDirForm: false,
      isMTDForm: false,
      pickedModel: "",
      showForm: false,
      showDetails: false,
      showEMRConfig: false,
      showFIRConfig: false,
      formType: "",
      tabSelected: "",
      tab2: "",
      isAdmin: false,
      noList: false,
      type: null,
      ismob: false,
      loading: true,
      list: [],
      fullList: [],
      isSearching: false,
      filter: "",
      selected: [],
      allSelected: false,
      nameRegEx: /^[a-zA-Z0-9_.-]*$/,
      valves: [],
      pumps: [],
      hydros: [],
      pulses: [],
      emrsensors: [],
      pirsensors: [],
      sensors: [],
      onoffs: [],
      sensorsi2c: [],
      sensorssdi: [],
      modbusSensors: [],
      modbusPumps: [],
      routes: [],
      listRoutes: [],
      emrData: {
        ADDR: null,
        ALTITUDE: "",
        H_ANEMOMETRO: "",
      },
      fertiValves: [], // válvulas JÁ ATRIBUÍDAS às válvulas de ferti
      firData: {
        // "formulário de configuração de ferti"
        ID: null,
        ADDR: null,
        ADT1: [], // ids de válvulas selectionadas para saída 1 de ferti
        ADT2: [], // ids de válvulas selectionadas para saída 2 de ferti
      },
      fields: [{ key: "CHECK" }, { key: "NAME", label: "Válvula" }],
      adt: "ADT1",
      firSel: {
        ADT1: false,
        ADT2: false,
      },
      firOpts: {
        ADT1: [], // opções de válvulas para saída 1 de ferti
        ADT2: [], // opções de válvulas para saída 2 de ferti
      },
      details: {},
      modelDirs: [],
      modelMtds: [],
      options: [
        {
          url: "devices",
          type: undefined,
          name: "DIR",
        },
        {
          url: "devices/models",
          type: "models",
          name: "MODELOS DE DIR",
        },
      ],
      // DROPDOWN de DIRS e MTD's
      optionsLeft: [],
      // Dropdown de model - SELECT
      models: [
        {
          url: "devices/models",
          type: "models",
          name: "MODELOS DE DIR",
        },
      ],
      regexOut: null,
      regexOp: null,
      regexPumpModbus: null,
      regexSensorModbus: null,
      regexDig: null,
      regexPul: null,
      regexSensor: null,
      regexOnOff: null,
      regexI2C: null,
      regexSDI12: null,
      regexMTD: null,
      missingResults: false,
      showErrorNotFound: false,
      showErrorNotSearch: false,
      temporaryList: null,
    };
  },
  created() {
    this.$emit("title-change", "Dirs");
    this.loadFertiValves();
    this.loadConnectedValves();
    this.loadRoutesPerAddr();
    this.isAdmin = Number(cookies.get("PERMISSION")) == 1;
    this.controller = new AbortController();
    this.regexOut = new RegExp("^EQUIP_ON_O");
    this.regexOp = new RegExp("F$");
    this.regexPumpModbus = new RegExp("^EQUIP_ON_M");
    this.regexSensorModbus = new RegExp("^EQUIP_ON_SM");
    this.regexDig = new RegExp("^EQUIP_ON_D");
    this.regexPul = new RegExp("^EQUIP_ON_P[0-9]");
    this.regexSensor = new RegExp("^EQUIP_ON_A");
    this.regexOnOff = new RegExp("^EQUIP_ON_L");
    this.regexI2C = new RegExp("^EQUIP_ON_I2C");
    this.regexSDI12 = new RegExp("^EQUIP_ON_SDI12");
    this.regexMTD = new RegExp("MTD");
    // CHECAR QUAL URL ESTOU PASSANDO
    this.loadOptionsLeft();
    this.getAlones();
    // Cerregar tudo
    this.isActive();
    this.monitRoutes();
  },
  beforeDestroy() {
    this.controller.abort();
    clearTimeout(this.timeout);
  },
  watch: {
    $route(to, from) {
      // devices/models
      if (to.params.type) {
        this.selected = [];
        this.allSelected = false;
        this.type = "models";
        this.isActive();
      } else {
        return;
      }
    },
    selected() {
      this.allSelected =
        !!this.selected.length && this.selected.length == this.list.length;
    },
    allADT1Sel() {
      this.firSel.ADT1 = this.firData.ADT1.length == this.firOpts.ADT1.length;
    },
    "firData.ADT1": function () {
      this.firSel.ADT1 = this.firData.ADT1.length == this.firOpts.ADT1.length;
    },
    allADT2Sel() {
      this.firSel.ADT2 = this.firData.ADT2.length == this.firOpts.ADT2.length;
    },
    "firData.ADT2": function () {
      this.firSel.ADT2 = this.firData.ADT2.length == this.firOpts.ADT2.length;
    },
  },
  computed: {
    computedClass() {
      let className = "row align-items-center header";
      if (this.mobile) {
        className = "row align-items-center header-mobile";
        return className;
      }
      return className;
    },
    detailsInfo() {
      let check = [
        this.details.VALVE &&
          this.details.VALVE.filter((e) => !!e.CURRENT_EQUIPMENT).length,
        this.details.P_MODBUS &&
          this.details.P_MODBUS.filter((e) => !!e.CURRENT_EQUIPMENT).length,
        this.details.S_MODBUS &&
          this.details.S_MODBUS.filter((e) => !!e.CURRENT_EQUIPMENT).length,
        this.details.HYDRO.filter((e) => !!e.CURRENT_EQUIPMENT).length &&
          !this.details.PULSE.filter((e) => !!e.CURRENT_EQUIPMENT).length,
        this.details.SENSOR &&
          this.details.SENSOR.filter((e) => !!e.CURRENT_EQUIPMENT).length,
        this.details.EMR,
        this.details.PIR,
        this.details.ONOFF &&
          this.details.ONOFF.filter((e) => !!e.CURRENT_EQUIPMENT).length,
        this.details.I2C &&
          this.details.I2C.filter((e) => !!e.CURRENT_EQUIPMENT).length,
        this.details.SDI12 &&
          this.details.SDI12.filter((e) => !!e.CURRENT_EQUIPMENT).length,
      ];
      return check.every((v) => {
        if (!v) {
          return true;
        }
      });
    },
    validFilter() {
      return !!this.filter.split(" ").join("");
    },
    ALTstate() {
      let A = this.emrData.ALTITUDE;
      return A >= 0 || (A != "" && String(Number(A)) != "NaN");
    },
    HANEMstate() {
      let H = this.emrData.H_ANEMOMETRO;
      return H != "" && String(Number(H)) != "NaN" && H >= 0;
    },
    filterUUIDsFromMtds() {
      // Filtrando dispositivos MTDs que serão usados para validação de campos UID

      if (this.formType === "edit") {
        if (this.selected.length) {
          return this.fullList
            .filter((device) => "UID" in device)
            .filter((mtd) => mtd.ID !== this.selected[0].ID)
            .map((mtd) => mtd.UID);
        }
      }
      return this.fullList
        .filter((device) => "UID" in device)
        .map((mtd) => mtd.UID);
    },
  },
  methods: {
    isDirsInRoutes(item) {
      let result = false;
      result = this.listRoutes.find((route) => {
        if (route.ADDR === item.ADDR) {
          return true;
        }
        return false;
      });
      return result;
    },
    clearSearchInput() {
      this.isSearching = false;
    },
    loadRoutesPerAddr() {
      routes
        .listPerAddr()
        .then((ret) => {
          this.routes = ret;
        })
        .catch((err) => {
          console.error(err);
          alert("Erro ao carregar dispositivos.");
        });
    },
    myRouteSelected() {
      if (this.type === "models") {
        this.isActive();
      } else {
        // this.title = "ALL";
        // this.tab2 = "";
        // this.type = null;
        this.isActive();
      }
    },
    async loadFertiValves() {
      return await firs
        .getValves()
        .then((fertivalves) => {
          this.fertiValves = fertivalves;
        })
        .catch((err) =>
          console.error(`Error ao carregar as FertiValves. ${err}`)
        );
    },
    async loadConnectedValves() {
      await valves
        .getConnecteds()
        .then((ret) => {
          if (ret.value.length) {
            let valvesWithoutFir = this.filterValvesWithNameModel(
              ret.value
            ).map((e) => ({
              ID: e.ID,
              NAME: e.NAME,
              ADDR: e.ADDR,
            }));

            this.firOpts.ADT1 = valvesWithoutFir;
            this.firOpts.ADT2 = JSON.parse(JSON.stringify(valvesWithoutFir));
          }
        })
        .catch((err) => console.error(`Error ao carregar as válvulas. ${err}`));
    },
    openValveTable(type) {
      this.adt = type;
      this.$refs.firValves.show();
    },
    filterValvesWithNameModel(value) {
      let regexFIR = /FIR/g;
      let removeFirs = value.filter((e) => {
        return !e.NAME_MODEL.match(regexFIR);
      });
      return removeFirs;
    },
    getAlones() {
      //try axios.all
      getAlones
        .hydro()
        .then((ret) => {
          this.hydros = ret;
        })
        .catch((err) => console.error(err));
      getAlones
        .pump()
        .then((ret) => {
          this.pumps = ret;
        })
        .catch((err) => console.error(err));
      getAlones
        .modbusPump()
        .then((ret) => {
          this.modbusPumps = ret;
        })
        .catch((err) => console.error(err));
      getAlones
        .modbusSensor()
        .then((ret) => {
          this.modbusSensors = ret;
        })
        .catch((err) => console.error(err));
      getAlones
        .emr()
        .then((ret) => {
          this.emrsensors = ret;
        })
        .catch((err) => console.error(err));
      getAlones
        .pir()
        .then((ret) => {
          this.pirsensors = ret;
        })
        .catch((err) => console.error(err));
      getAlones
        .sensor()
        .then((ret) => {
          this.sensors = ret;
        })
        .catch((err) => console.error(err));
      getAlones
        .pulse()
        .then((ret) => {
          this.pulses = ret;
        })
        .catch((err) => console.error(err));
      getAlones
        .onoff()
        .then((ret) => (this.onoffs = ret))
        .catch((err) => console.error(err));
      getAlones
        .i2c()
        .then((ret) => {
          this.sensorsi2c = ret;
        })
        .catch((err) => console.error(err));
      getAlones
        .sdi12()
        .then((ret) => {
          this.sensorssdi = ret;
        })
        .catch((err) => console.error(err));
      getAlones
        .valve()
        .then((ret) => {
          this.valves = ret;
        })
        .catch((err) => console.error(err));
    },
    //para dirs e estações
    openDetails(item) {
      this.details = item;
      this.showDetails = true;
    },
    //checkboxes
    toggleAll() {
      this.allSelected = !this.allSelected;
      if (this.selected.length < this.list.length)
        this.selected = this.list.slice();
      else if (this.selected.length == this.list.length) this.selected = [];
    },
    toggleAllValves(str) {
      this.firSel[str] = !this.firSel[str];
      if (
        this.firOpts[str].length &&
        this.firData[str].length < this.firOpts[str].length
      ) {
        this.firData[str] = this.firOpts[str].map((e) => e.ID);
      } else if (this.firData[str].length == this.firOpts[str].length) {
        this.firData[str] = [];
      }
    },
    //excluir itens da lista de selecionados
    remove() {
      this.$refs.removeDirs.show();
    },
    confirmRemove() {
      if (this.type == "models") {
        modelsDir
          .del(this.selected)
          .then((ret) => {
            alert(ret.log, ret.alert);
            if (ret.alert == "s") {
              this.loadModels();
              this.selected = [];
            }
          })
          .catch((err) => {
            alert("Ocorreu um erro. Tente novamente.");
            this.selected = [];
          });
      } else {
        this.selected.map((e) => {
          // Se for MTD então irá deletar o MTD
          if (this.regexMTD.test(e.MODEL_NAME)) {
            mtd
              .del(this.selected)
              .then((ret) => {
                alert(ret.log, ret.alert);
                if (ret.alert == "s") {
                  this.selected = [];
                }
                this.isActive();
              })
              .catch((err) => {
                alert("Ocorreu um erro. Tente novamente.");
                this.selected = [];
              });
          } else {
            dirs
              .del(this.selected)
              .then((ret) => {
                alert(ret.log, ret.alert);
                if (ret.alert == "s") {
                  this.selected = [];
                }
                this.isActive();
              })
              .catch((err) => {
                alert("Ocorreu um erro. Tente novamente.");
                this.selected = [];
              });
          }
        });
        // dirs
        //   .del(this.selected)
        //   .then((ret) => {
        //     alert(ret.log, ret.alert);
        //     if (ret.alert == "s") {
        //       this.loadDirs();
        //       this.selected = [];
        //     }
        //   })
        //   .catch((err) => {
        //     alert("Ocorreu um erro. Tente novamente.");
        //     this.selected = [];
        //   });
      }
      this.$refs.removeDirs.hide();
    },
    // data= RET, action= FORMTYPE
    submitDir(data, action) {
      dirs[action](data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          if (ret.alert == "s") {
            this.loadConnectedValves();
            // this.loadDirs();
            this.resetForm();
          }
          this.showForm = false;
          this.isActive();
        })
        .catch((err) => {
          alert("Ocorreu um erro na submissão dos dados. Tente novamente.");
          this.showForm = false;
          this.resetForm();
        });
    },
    submitMtd(data, action) {
      // Irá selecionar a chave e irá passar o data
      mtd[action](data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          if (ret.alert == "s") {
            this.resetForm();
          }
          this.showForm = false;
          this.isActive();
        })
        .catch((err) => {
          alert("Ocorreu um erro na submissão dos dados. Tente novamente.");
          this.showForm = false;
          this.resetForm();
        });
    },
    submitModel(data) {
      modelsDir[this.formType](data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          if (ret.status) {
            this.resetForm();
            this.loadModels();
          }
          this.showForm = false;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro na submissão dos dados. Tente novamente. ",
            err
          );
          this.showForm = false;
          this.resetForm();
        });
    },
    edit() {
      this.getAlones();
      if (this.regexMTD.test(this.selected[0].MODEL_NAME)) {
        this.formType = "edit";
        this.showForm = true;
        this.isMTDForm = true;
        this.idDirForm = false;
      } else {
        this.idDirForm = true;
        this.isMTDForm = false;
        this.formType = "edit";
        this.showForm = true;
      }
    },
    formShowAdd(model) {
      this.getAlones();
      if (this.regexMTD.test(model.NAME)) {
        this.isMTDForm = true;
        this.idDirForm = false;
        this.pickedModel = model;
        this.add();
      } else {
        this.idDirForm = true;
        this.isMTDForm = false;
        this.pickedModel = model;
        this.add();
      }
    },
    // O que é RESET DIR?
    resetDir(e) {
      if (
        confirm(
          "Você tem certeza que deseja desassociar todos os equipamentos deste dispositivo?"
        )
      ) {
        dirs
          .edit({
            ID: this.selected[0].ID,
            ADDR: this.selected[0].ADDR,
            LATITUDE: parseFloat(this.selected[0].LATITUDE),
            LONGITUDE: parseFloat(this.selected[0].LONGITUDE),
            O1: null,
            O1F: null,
            O2: null,
            O2F: null,
            O3: null,
            O3F: null,
            O4: null,
            O4F: null,
            O5: null,
            O5F: null,
            O6: null,
            O6F: null,
            O7: null,
            O7F: null,
            O8: null,
            O8F: null,
            O9: null,
            O9F: null,
            O10: null,
            O10F: null,
            O11: null,
            O11F: null,
            O12: null,
            O12F: null,
            O13: null,
            O13F: null,
            O14: null,
            O14F: null,
            O15: null,
            O15F: null,
            O16: null,
            O16F: null,
            O17: null,
            O17F: null,
            O18: null,
            O18F: null,
            O19: null,
            O19F: null,
            O20: null,
            O20F: null,
            O21: null,
            O21F: null,
            O22: null,
            O22F: null,
            O23: null,
            O23F: null,
            O24: null,
            O24F: null,
            O25: null,
            O25F: null,
            O26: null,
            O26F: null,
            O27: null,
            O27F: null,
            O28: null,
            O28F: null,
            O29: null,
            O29F: null,
            O30: null,
            O30F: null,
            O31: null,
            O31F: null,
            O32: null,
            O32F: null,
            M1: null,
            M2: null,
            M3: null,
            M4: null,
            M5: null,
            M6: null,
            M7: null,
            M8: null,
            SM1: null,
            SM2: null,
            SM3: null,
            SM4: null,
            SM5: null,
            SM6: null,
            SM7: null,
            SM8: null,
            D1: null,
            D2: null,
            D3: null,
            D4: null,
            D5: null,
            D6: null,
            D7: null,
            D8: null,
            L1: null,
            L2: null,
            L3: null,
            L4: null,
            L5: null,
            L6: null,
            L7: null,
            L8: null,
            P1: null,
            P2: null,
            P3: null,
            P4: null,
            P5: null,
            P6: null,
            P7: null,
            P8: null,
            A1: null,
            A2: null,
            A3: null,
            A4: null,
            A5: null,
            A6: null,
            A7: null,
            A8: null,
            I2C: null,
            I2C1: null,
            I2C2: null,
            I2C3: null,
            I2C4: null,
            I2C5: null,
            I2C6: null,
            I2C7: null,
            SDI12: null,
            SDI12I1: null,
            SDI12I2: null,
            SDI12I3: null,
            SDI12I4: null,
            SDI12I5: null,
            SDI12I6: null,
            SDI12I7: null,
            EMR: null,
            PIR: null,
            FK_MODEL: this.selected[0].FK_MODEL,
          })
          .then((ret) => {
            alert(ret.log, ret.alert);
            if (ret.alert == "s") {
              this.renderAloneDirs();
              this.$refs.editDir.hide();
              this.resetForm();
            }
          })
          .catch((err) => {
            this.$refs.editDir.hide();
            this.resetForm();
          });
      }
    },
    //adicionar um novo equipamento ao sistema
    add() {
      this.resetForm();
      this.formType = "add";
      this.showForm = true;
    },
    //configuração de estação
    emrConfig(item) {
      this.emrData.ADDR = item.ADDR;
      this.emrData.ALTITUDE = item.ALTITUDE >= 0 ? item.ALTITUDE : "";
      this.emrData.H_ANEMOMETRO = item.H_ANEMOMETRO ? item.H_ANEMOMETRO : "";
      this.showEMRConfig = true;
    },
    submitEmrConfig(e) {
      let data = {
        ADDR: this.emrData.ADDR,
        ALTITUDE: parseFloat(this.emrData.ALTITUDE),
        H_ANEMOMETRO: parseFloat(this.emrData.H_ANEMOMETRO),
      };
      if (this.ALTstate && this.HANEMstate) {
        stations
          .config(data)
          .then((ret) =>
            this.renderAllDirs()
              .then((data) => {
                this.list = data;
                this.fullList = this.list.map((e) => e);
                return;
              })
              .catch((err) => console.error(err))
              .then((_) => (this.loading = false))
              .then((_) => {
                if (
                  !this.list.length &&
                  this.showErrorNotSearch === false &&
                  !this.loading
                ) {
                  this.showErrorNotFound = true;
                } else {
                  this.showErrorNotFound = false;
                }
              })
          )
          .catch((err) =>
            console.error(`Error ao submeter configurações do Emr.${err}`)
          )
          .then((_) => (this.showEMRConfig = false));
      }
    },
    resetEmrConfig() {
      this.emrData = {
        ADDR: null,
        ALTITUDE: "",
        H_ANEMOMETRO: "",
      };
    },
    //configuração de dispositivo de ferti
    firConfig(item) {
      this.firData.ID = item.ID;
      this.firData.ADDR = item.ADDR;
      this.firData.ADT1 = item.ADT1;
      this.firData.ADT2 = item.ADT2;
      this.showForm = false;
      this.showFIRConfig = true;
    },
    async submitFirConfig(e) {
      let { ID, ADDR, ADT1, ADT2 } = this.firData;
      let data = { ID, ADDR, ADT1, ADT2 };
      await firs
        .config(data)
        .then(async (ret) => {
          await this.loadFertiValves();
          return;
        })
        .then(
          async (ret) =>
            await this.renderAllDirs()
              .then((data) => {
                this.list = data;
                this.fullList = this.list.map((e) => e);
                return;
              })
              .then((_) => (this.loading = false))
              .then((_) => {
                if (
                  !this.list.length &&
                  this.showErrorNotSearch === false &&
                  !this.loading
                ) {
                  this.showErrorNotFound = true;
                } else {
                  this.showErrorNotFound = false;
                }
              })
        )
        .then(async (_) => {
          alert("Dispositivo atualizado com sucesso", "s");
          await this.loadConnectedValves();
        })
        .then((_) => (this.showFIRConfig = false))
        .catch((err) => {
          console.error(`Error ao submeter configurações do Fir. ${err}`);
          alert("Ocorreu um erro ao atualizar o dispositivo", "e");
        });
    },
    resetFirConfig() {
      this.firData = {
        ID: null,
        ADDR: null,
        ADT1: [],
        ADT2: [],
      };
    },
    //resetar formulários ao fechar ou submeter os modais
    resetForm() {
      this.formType = "";
      this.selected = [];
    },
    //carregamento de dados
    loadModels() {
      this.loading = true;
      this.showErrorNotFound = false;
      modelsDir
        .list()
        .then((ret) => {
          this.list = ret;
          if (!this.optionsLeft) {
            this.optionsLeft = ret;
          }
          // this.loadOptionsLeft();
          this.fullList = this.list.map((e) => e);
        })
        .catch((err) => {
          console.error(`Error ao carregar os modelos -> ${err}`);
          this.optionsLeft = [];
          return;
        })
        .then((_) => (this.loading = false))
        .then((_) => {
          if (
            !this.list.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        });
    },
    //carregamento de dados
    loadOptionsLeft() {
      modelsDir
        .list()
        .then((ret) => {
          this.optionsLeft = ret;
          this.modelDirs = ret;
        })
        .catch((err) => {
          console.error(`Error ao carregar os models e optionsLeft -> ${err}`);
          this.optionsLeft = [];
        });
    },
    loadMtd() {
      return new Promise((resolve, reject) => {
        let mtd_list = [];
        mtd
          .list()
          .then((ret) => {
            mtd_list = this.organizeMtd(ret);
            return;
          })
          .then((_) => resolve(mtd_list))
          .catch((err) => {
            console.error(err);
            reject(`Error ao carregar os MTD's > : ${err}`);
          });
      });
    },
    loadDirs() {
      return new Promise((resolve, reject) => {
        let dirs_list = [];
        dirs
          .list()
          .then((ret) => {
            dirs_list = this.organizeDirs(ret);
            return;
          })
          .then((_) => resolve(dirs_list))
          .catch((err) => {
            console.error(err);
            reject(`Error ao carregar os DIRS > : ${err}`);
          });
      });
    },
    async renderAllDirs() {
      return await new Promise((resolve, reject) => {
        let dirs_list = [];
        Promise.all([
          dirs.list().catch((err) => err),
          mtd.list().catch((err) => err),
        ])
          .then((all_dirs) => {
            // DIRS
            if (!!all_dirs[0].length && all_dirs[0].length > 0) {
              dirs_list.push(...this.organizeDirs(all_dirs[0]));
            }
            // MTD
            if (!!all_dirs[1].length && all_dirs[1].length > 0) {
              dirs_list.push(...this.organizeMtd(all_dirs[1]));
            }
            return;
          })
          .then((_) => {
            return resolve(dirs_list);
          })
          .catch((err) => {
            console.error(
              "Error no registers/devices -> renderAllDirs : ",
              err
            );
            return reject(err);
          });
      });
    },
    renderAloneDirs() {
      this.showErrorNotFound = false;
      this.loading = true;
      this.loadDirs()
        .then((data) => {
          this.list = data.filter((e) => e.MODEL_NAME === this.type);
          this.fullList = this.list.map((e) => e);
          return;
        })
        .catch((err) => console.error(err))
        .then((_) => (this.loading = false))
        .then((_) => {
          if (
            !this.list.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        });
    },
    renderAloneMTDs() {
      this.showErrorNotFound = false;
      this.loading = true;
      this.loadMtd()
        .then((data) => {
          this.list = data.filter((e) => e.MODEL_NAME === this.type);
          this.fullList = this.list.map((e) => e);
          return;
        })
        .catch((err) => console.error(err))
        .then((_) => (this.loading = false))
        .then((_) => {
          if (
            !this.list.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        });
    },
    selectType(type) {
      this.type = type;
      this.isActive();
    },
    // referente à sinalização na aba de Equipamentos
    // também faz a troca dos itens para disposição na tela
    isActive() {
      this.list = [];
      this.fullList = [];
      this.isSearching = false;
      this.filter = "";
      const regexMTD = new RegExp("MTD");
      // DIRS
      if (this.type != "models" && this.type && !regexMTD.test(this.type)) {
        this.tabSelected = this.type;
        this.title = "DIR";
        this.selected = [];
        this.allSelected = false;
        this.renderAloneDirs();
      } else if (this.$route.params.type === "models") {
        this.tabSelected = "";
        this.title = "MODEL";
        this.selected = [];
        this.allSelected = false;
        this.type = "models";
        this.loadModels();
      }
      // Quando for MTD
      else if (regexMTD.test(this.type)) {
        this.tabSelected = this.type;
        this.title = "MTD";
        this.selected = [];
        this.allSelected = false;
        this.renderAloneMTDs();
      } else if (!this.type) {
        this.tabSelected = "EXIBIR DIRS";
        this.title = "ALL";
        this.selected = [];
        this.allSelected = false;
        this.showErrorNotFound = false;
        this.loading = true;
        this.renderAllDirs()
          .then((data) => {
            this.list = data;
            this.fullList = this.list.map((e) => e);
            return;
          })
          .catch((err) => console.error(err))
          .then((_) => (this.loading = false))
          .then((_) => {
            if (
              !this.list.length &&
              this.showErrorNotSearch === false &&
              !this.loading
            ) {
              this.showErrorNotFound = true;
            } else {
              this.showErrorNotFound = false;
            }
          });
      }
    },
    monitRoutes() {
      // responsável pela árvore
      routes
        .monitRoutes(this.controller)
        .then((ret) => {
          this.listRoutes = ret;
          return;
        })
        .catch((err) => {
          console.error(err);
          return err.name;
        });
      // .then((ret) => {
      //   if (ret !== "AbortError") {
      //     this.timeout = setTimeout(this.monitRoutes, 5000);
      //   }
      // });
    },
    organizeMtd(mtds) {
      for (let i = 0; i < mtds.length; i++) {
        let item = mtds[i];
        let operation = [];
        let hydro = [];
        let pulse = [];
        let onoff = [];
        let valve = [];
        let i2c = [];
        let sdi12 = [];
        let regexPos = /[0-9]+/g;
        let keys = Object.keys(item);

        for (let key of keys) {
          if (this.regexOut.test(key)) {
            valve.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["O" + key.match(regexPos)[0]], //id
              CURRENT_EQUIPMENT: item["O" + key.match(regexPos)[0]], //id
              POSITION: Number(key.match(regexPos)[0]),
            });
          } else if (this.regexOp.test(key)) {
            operation.push({
              OPERATION:
                item[key] == 0 || item[key] == 1 || item[key] == 2
                  ? item[key]
                  : 2,
            });
          } else if (this.regexPumpModbus.test(key)) {
            p_modbus.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["M" + key.match(regexPos)[0]],
              CURRENT_EQUIPMENT: item["M" + key.match(regexPos)[0]],
              POSITION: Number(key.match(regexPos)[0]),
            });
          } else if (this.regexSensorModbus.test(key)) {
            s_modbus.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["SM" + key.match(regexPos)[0]],
              CURRENT_EQUIPMENT: item["SM" + key.match(regexPos)[0]],
              POSITION: Number(key.match(regexPos)[0]),
            });
          } else if (this.regexDig.test(key)) {
            hydro.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["D" + key.match(regexPos)[0]]
                ? "h" + item["D" + key.match(regexPos)[0]]
                : null, //id personalizado para hidrômetro
              CURRENT_EQUIPMENT: item["D" + key.match(regexPos)[0]]
                ? "h" + item["D" + key.match(regexPos)[0]]
                : null, //id personalizado para hidrômetro
              POSITION: Number(key.match(regexPos)[0]),
            });
          } else if (this.regexPul.test(key)) {
            pulse.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["P" + key.match(regexPos)[0]]
                ? "p" + item["P" + key.match(regexPos)[0]]
                : null, //id personalizado para sensor de pulso
              CURRENT_EQUIPMENT: item["P" + key.match(regexPos)[0]]
                ? "p" + item["P" + key.match(regexPos)[0]]
                : null, //id personalizado para sensor de pulso
              POSITION: Number(key.match(regexPos)[0]),
            });
          } else if (this.regexOnOff.test(key)) {
            onoff.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["L" + key.match(regexPos)[0]], //id
              CURRENT_EQUIPMENT: item["L" + key.match(regexPos)[0]], //id
              POSITION: Number(key.match(regexPos)[0]),
            });
          } else if (this.regexSensor.test(key)) {
            sensor.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["A" + key.match(regexPos)[0]], //id
              CURRENT_EQUIPMENT: item["A" + key.match(regexPos)[0]], //id
              POSITION: Number(key.match(regexPos)[0]),
            });
          } else if (this.regexI2C.test(key)) {
            let columnIdx = key.match(regexPos)[1]; //pega o segundo do array pois o primeiro é '2' de I2C
            i2c.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["I2C" + (columnIdx ? columnIdx : "")],
              CURRENT_EQUIPMENT: item["I2C" + (columnIdx ? columnIdx : "")],
              POSITION: Number(columnIdx ? columnIdx : "0"),
            });
          } else if (this.regexSDI12.test(key)) {
            let columnIdx = key.match(regexPos)[1]; //pega o segundo do array pois o primeiro é '12' de SDI12I*
            if (
              mtds[i].SDI12_CAPACITY == 1 &&
              columnIdx &&
              Number(columnIdx) <= mtds[i].SDI12_CAPACITY
            ) {
              sdi12.push({
                NAME_EQUIPMENT: item[key],
                EQUIPMENT: item["SDI12" + "I" + columnIdx],
                CURRENT_EQUIPMENT: item["SDI12" + "I" + columnIdx],
                POSITION: Number(columnIdx),
              });
            } else if (
              columnIdx &&
              Number(columnIdx) <= mtds[i].SDI12_CAPACITY
            ) {
              sdi12.push({
                NAME_EQUIPMENT: item[key],
                EQUIPMENT: item["SDI12" + "I" + columnIdx],
                CURRENT_EQUIPMENT: item["SDI12" + "I" + columnIdx],
                POSITION: Number(columnIdx),
              });
            }
          }
        }

        onoff.length = 4;
        valve.length = 4;
        operation.length = 4;

        let valve_and_operation = [];
        for (let v = 0; v < valve.length; v++) {
          valve_and_operation.push({
            NAME_EQUIPMENT: valve[v].NAME_EQUIPMENT,
            EQUIPMENT: valve[v].EQUIPMENT,
            CURRENT_EQUIPMENT: valve[v].CURRENT_EQUIPMENT,
            POSITION: valve[v].POSITION,
            OPERATION: operation[v].OPERATION,
          });
        }

        hydro.length = mtds[i].DIGITAL_CAPACITY;
        pulse.length = mtds[i].DIGITAL_CAPACITY;
        i2c.length = mtds[i].I2C_CAPACITY;
        sdi12.length =
          mtds[i].SDI12_CAPACITY > 1
            ? mtds[i].SDI12_CAPACITY
            : mtds[i].SDI12_CAPACITY;
        // sdi12.length = mtds[i].SDI12_CAPACITY;
        mtds[i]["HYDRO"] = hydro;
        mtds[i]["PULSE"] = pulse;
        mtds[i]["ONOFF"] = onoff;
        mtds[i]["I2C"] = i2c;
        mtds[i]["VALVE"] = valve_and_operation;
        mtds[i]["SDI12"] = sdi12;
      }
      return mtds;
    },
    organizeDirs(dirs) {
      for (let i = 0; i < dirs.length; i++) {
        let item = dirs[i];
        let valve = [];
        let s_modbus = [];
        let p_modbus = [];
        let operation = [];
        let hydro = [];
        let pulse = [];
        let sensor = [];
        let onoff = [];
        let i2c = [];
        let sdi12 = [];
        let regexPos = /[0-9]+/g;
        let keys = Object.keys(item);

        for (let key of keys) {
          if (this.regexOut.test(key)) {
            valve.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["O" + key.match(regexPos)[0]], //id
              CURRENT_EQUIPMENT: item["O" + key.match(regexPos)[0]], //id
              POSITION: Number(key.match(regexPos)[0]),
            });
          } else if (this.regexOp.test(key)) {
            operation.push({
              OPERATION:
                item[key] == 0 || item[key] == 1 || item[key] == 2
                  ? item[key]
                  : 2,
            });
          } else if (this.regexPumpModbus.test(key)) {
            p_modbus.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["M" + key.match(regexPos)[0]],
              CURRENT_EQUIPMENT: item["M" + key.match(regexPos)[0]],
              POSITION: Number(key.match(regexPos)[0]),
            });
          } else if (this.regexSensorModbus.test(key)) {
            s_modbus.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["SM" + key.match(regexPos)[0]],
              CURRENT_EQUIPMENT: item["SM" + key.match(regexPos)[0]],
              POSITION: Number(key.match(regexPos)[0]),
            });
          } else if (this.regexDig.test(key)) {
            hydro.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["D" + key.match(regexPos)[0]]
                ? "h" + item["D" + key.match(regexPos)[0]]
                : null, //id personalizado para hidrômetro
              CURRENT_EQUIPMENT: item["D" + key.match(regexPos)[0]]
                ? "h" + item["D" + key.match(regexPos)[0]]
                : null, //id personalizado para hidrômetro
              POSITION: Number(key.match(regexPos)[0]),
            });
          } else if (this.regexPul.test(key)) {
            pulse.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["P" + key.match(regexPos)[0]]
                ? "p" + item["P" + key.match(regexPos)[0]]
                : null, //id personalizado para sensor de pulso
              CURRENT_EQUIPMENT: item["P" + key.match(regexPos)[0]]
                ? "p" + item["P" + key.match(regexPos)[0]]
                : null, //id personalizado para sensor de pulso
              POSITION: Number(key.match(regexPos)[0]),
            });
          } else if (this.regexOnOff.test(key)) {
            onoff.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["L" + key.match(regexPos)[0]], //id
              CURRENT_EQUIPMENT: item["L" + key.match(regexPos)[0]], //id
              POSITION: Number(key.match(regexPos)[0]),
            });
          } else if (this.regexSensor.test(key)) {
            sensor.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["A" + key.match(regexPos)[0]], //id
              CURRENT_EQUIPMENT: item["A" + key.match(regexPos)[0]], //id
              POSITION: Number(key.match(regexPos)[0]),
            });
          } else if (this.regexI2C.test(key)) {
            let columnIdx = key.match(regexPos)[1]; //pega o segundo do array pois o primeiro é '2' de I2C
            i2c.push({
              NAME_EQUIPMENT: item[key],
              EQUIPMENT: item["I2C" + (columnIdx ? columnIdx : "")],
              CURRENT_EQUIPMENT: item["I2C" + (columnIdx ? columnIdx : "")],
              POSITION: Number(columnIdx ? columnIdx : "0") + 1,
            });
          } else if (this.regexSDI12.test(key)) {
            let columnIdx = key.match(regexPos)[1]; //pega o segundo do array pois o primeiro é '12' de SDI12I*
            if (
              dirs[i].SDI12_CAPACITY == 1 &&
              columnIdx &&
              Number(columnIdx) <= dirs[i].SDI12_CAPACITY
            ) {
              sdi12.push({
                NAME_EQUIPMENT: item[key],
                EQUIPMENT: item["SDI12" + "I" + columnIdx],
                CURRENT_EQUIPMENT: item["SDI12" + "I" + columnIdx],
                POSITION: Number(columnIdx),
              });
            } else if (
              columnIdx &&
              Number(columnIdx) < dirs[i].SDI12_CAPACITY
            ) {
              sdi12.push({
                NAME_EQUIPMENT: item[key],
                EQUIPMENT: item["SDI12" + "I" + columnIdx],
                CURRENT_EQUIPMENT: item["SDI12" + "I" + columnIdx],
                POSITION: Number(columnIdx),
              });
              //   sdi12.push({
              //   NAME_EQUIPMENT: item[key],
              //   EQUIPMENT: item["SDI12" + (columnIdx ? "I" + columnIdx : "")],
              //   CURRENT_EQUIPMENT:
              //     item["SDI12" + (columnIdx ? "I" + columnIdx : "")],
              //   POSITION: Number(columnIdx ? columnIdx : "0") + 1,
              // });
            }
          }
        }
        s_modbus.length = 8;
        p_modbus.length = 8;
        onoff.length = 8;
        valve.length = dirs[i].VALVE_CAPACITY;
        operation.length = dirs[i].VALVE_CAPACITY;
        hydro.length = dirs[i].DIGITAL_CAPACITY;
        pulse.length = dirs[i].DIGITAL_CAPACITY;
        sensor.length = dirs[i].SENSOR_CAPACITY;
        i2c.length = dirs[i].I2C_CAPACITY;
        sdi12.length =
          dirs[i].SDI12_CAPACITY > 1
            ? dirs[i].SDI12_CAPACITY - 1
            : dirs[i].SDI12_CAPACITY;
        let valve_and_operation = [];
        for (let v = 0; v < valve.length; v++) {
          valve_and_operation.push({
            NAME_EQUIPMENT: valve[v].NAME_EQUIPMENT,
            EQUIPMENT: valve[v].EQUIPMENT,
            CURRENT_EQUIPMENT: valve[v].CURRENT_EQUIPMENT,
            POSITION: valve[v].POSITION,
            OPERATION: operation[v].OPERATION,
          });
        }
        dirs[i]["P_MODBUS"] = p_modbus;
        dirs[i]["S_MODBUS"] = s_modbus;
        dirs[i]["VALVE"] = valve_and_operation;
        dirs[i]["HYDRO"] = hydro;
        dirs[i]["PULSE"] = pulse;
        dirs[i]["SENSOR"] = sensor;
        dirs[i]["ONOFF"] = onoff;
        dirs[i]["I2C"] = i2c;
        dirs[i]["SDI12"] = sdi12;
      }
      dirs.map((e) => {
        if (e.MODEL_NAME.indexOf("EMR") > -1) {
          stations.get(e.ADDR).then((ret) => {
            const hasStationData = !!ret.value.length;
            const altitude = hasStationData ? ret.value[0].ALTITUDE : null;
            const h_anemometro = hasStationData
              ? ret.value[0].H_ANEMOMETRO
              : null;

            e.ALTITUDE = altitude >= 0 ? altitude : null;
            e.H_ANEMOMETRO = h_anemometro;
          });
        } else if (e.MODEL_NAME.indexOf("FIR") > -1) {
          if (this.fertiValves.length) {
            e.ADT1 = this.fertiValves.filter(
              (fv) => fv.ADDR == e.ADDR && fv.ADT == 1
            );
            if (e.ADT1.length) e.ADT1 = e.ADT1.map((e) => e.ID);
            e.ADT2 = this.fertiValves.filter(
              (fv) => fv.ADDR == e.ADDR && fv.ADT == 2
            );
            if (e.ADT2.length) e.ADT2 = e.ADT2.map((e) => e.ID);
          } else {
            e.ADT1 = [];
            e.ADT2 = [];
          }
        } else return e;
      });
      return dirs;
    },
    digitalInput(idx) {
      let hydro = this.details.HYDRO[idx].NAME_EQUIPMENT;
      let pulse = this.details.PULSE[idx].NAME_EQUIPMENT;
      if (hydro) return hydro + " | Hidrômetro";
      else if (pulse) return pulse + " | Sensor de pulso";
      else return "";
    },
    getOperationMode(mode) {
      if (mode == 0) return " | Fechar";
      else if (mode == 1) return " | Abrir";
      else return ""; //se mode == 2 é abrir e fechar
    },
    resetDropdown() {
      this.isSearching = false;
      this.showErrorNotSearch = false;
      this.list = this.fullList;
      this.$refs.INP.clearText();
    },
    searchBy(filter) {
      this.selected = [];
      this.isSearching = !!filter.split(" ").join("");
      this.filter = filter.toUpperCase();
      if (this.isSearching && this.validFilter && this.fullList.length) {
        this.list = this.fullList.filter((item) => {
          if (this.type !== "models") {
            if (
              item.MODEL_NAME &&
              item.MODEL_NAME.toString().indexOf(this.filter) > -1
            ) {
              return true;
            } else if (
              item.ADDR &&
              item.ADDR.toString().indexOf(this.filter) > -1
            ) {
              return true;
            }
          } else if (this.type === "models") {
            if (item.NAME && item.NAME.toString().indexOf(this.filter) > -1) {
              return true;
            }
            return item.MAKER.toString().indexOf(this.filter) > -1;
          }
        });
        if (this.list.length) {
          this.showErrorNotSearch = false;
        } else {
          this.showErrorNotSearch = true;
        }
      } else {
        this.list = this.fullList.map((e) => e);
      }
    },
    clearSearch() {
      this.selected = [];
      this.isSearching = false;
      this.$refs.INP.clearText();
      this.showErrorNotSearch = false;
      this.list = this.fullList.map((e) => e);
    },
  },
};
</script>
<style scoped>
.details-btn {
  font-size: 1.2em;
  color: var(--text-gray-primary);
}
.register-page #form {
  padding-bottom: 50px;
}
.dir-card {
  max-height: 235px;
  min-height: 200px;
}
.scrollable {
  max-height: 260px;
  overflow-y: auto;
  line-height: 1.4em;
}
.card-name {
  display: flex;
  font-family: "SourceSansPro_Semibold", Arial, Helvetica, sans-serif;
  justify-content: space-between;
  align-items: center;
}
.card-name .material-design-icon {
  font-size: 1.3em;
  color: var(--green-3v3);
}
.show-details-cards {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 3px;
}
.show-details-cards a {
  padding: 3px 6px;
  border-radius: 5px;
  border: 1px solid #bebebe;
  font-weight: 500;
  font-size: 0.7em;
  color: #a1a1a1;
  transition: all 0.4s ease;
}
.show-details-cards a:hover {
  background: #f5f5f5;
}
.header h5 {
  font-weight: 600;
  color: var(--text-gray-primary);
}
.header-card h5 {
  color: var(--text-gray-primary);
  font-weight: 600;
}
.row-details-card {
  width: 100%;
  padding-top: 4.5px;
  overflow-y: auto;
  align-items: flex-start;
  font-size: 0.86em;
  color: var(--text-gray-primary);
  line-height: 1.4em;
}
.row-details-card div {
  display: flex;
}
.row-details-card strong {
  margin-right: 3px;
}
.info {
  color: #e07f52;
  font-size: 0.88em;
}
.info-config {
  color: var(--text-gray-primary);
  font-size: 0.85em;
}
.info-container {
  padding: 4px;
  border: solid 1px #bebebe;
  border-radius: 4px;
}
.table-scrollable {
  overflow: auto;
  max-height: 250px;
}
#details .selected-box {
  height: auto;
}
#details .content {
  margin: 0;
}
.scrollable {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 2px;
}
.selected-scrollable div {
  background-color: #eeeeee;
  color: #6d6d6d;
  width: 100%;
  margin-bottom: 2px;
  padding-left: 5px;
}
.identifier {
  display: inline-block;
  margin: 3px 0;
}
.identifier::after {
  content: " - ";
}
#details {
  padding-top: 100px;
  padding-bottom: 0 !important;
}
.equipment-table {
  height: 310px !important;
  overflow-x: hidden;
  overflow-y: auto;
}
.footer {
  height: 35px;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-mobile {
  min-height: 29px;
}
@media screen and (max-width: 991px) {
  .register-main {
    margin-bottom: 70px;
  }
}
@media screen and (max-width: 767px) {
  #details {
    top: var(--size-bars);
    height: calc(100vh - var(--size-bars));
    padding-top: 0;
    width: 100vw;
    display: flex;
    flex-direction: column;
  }
  #details header {
    position: relative;
    top: auto;
    width: 100%;
    flex-shrink: 0;
  }
  #details .content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 8px !important;
  }
  #details footer {
    position: relative;
    bottom: auto;
    width: 100%;
    flex-shrink: 0;
  }
  #details .selected-box {
    height: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding: 4px;
  }
  #details .selected-box .selected-item {
    width: calc(50% - 2px);
    margin-bottom: 0;
    box-sizing: border-box;
  }
  #form {
    padding-top: 1em;
  }
  .header {
    min-height: 90px;
  }
}
</style>
